import { List, DrawerProps as BaseDrawerProps } from '@mui/material'
import { ModuleRoute } from 'shared/types'
import DrawerItemLink from './DrawerItemLink'
import SubrouteList from './SubrouteList'
import { ListContainer, StyledDrawer } from './Drawer.style'

export interface DrawerProps extends Partial<BaseDrawerProps> {
  navItems: ModuleRoute[]
  hidden?: boolean
  onClose?: () => void
}

const Drawer = ({ hidden, navItems, onClose, ...props }: DrawerProps) => {
  if (hidden) return null
  return (
    <StyledDrawer anchor="left" variant="permanent" {...props}>
      <ListContainer>
        <List disablePadding>
          {navItems.map(
            (
              { path, exact, sensitive, strict, linkSettings = {}, subroutes },
              i
            ) =>
              subroutes ? (
                <SubrouteList
                  data={subroutes}
                  {...linkSettings}
                  key={`nav-item-list${i}`}
                  onClose={onClose}
                />
              ) : (
                <DrawerItemLink
                  key={`nav-item-${i}`}
                  path={path}
                  to={(linkSettings as any)?.to || path}
                  {...linkSettings}
                  onClick={onClose}
                />
              )
          )}
        </List>
      </ListContainer>
    </StyledDrawer>
  )
}

export default Drawer
